import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './store/store'
import router from './router'
import 'babel-polyfill'
import 'styles/reset.css'
import 'styles/border.css'
import 'styles/iconfont.css'
import 'swiper/dist/css/swiper.css'
import FastClick from 'fastclick'
import 'lib-flexible'
import Socket from './socket/socket'
import axios from 'axios'
import QS from 'qs'

const bwtHybrid = require('../static/bwtHybrid.min.js')
Vue.use(Socket)
Vue.use(Vuex)
Vue.config.productionTip = false
FastClick.attach(document.body)
Vue.prototype.$axios = axios
Vue.prototype.qs = QS
Vue.prototype.$bwtHybrid = bwtHybrid
axios.defaults.baseURL = 'https://www.mosunshine.com/Umbrella'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    this.$bwtHybrid.config({
      jsApiList: ['cashier']
    })
    this.$bwtHybrid.ready(function () {
      console.log('注册成功')
    })
    FastClick.prototype.focus = function (targetElement) {
      let length
      if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
        length = targetElement.value.length
        targetElement.focus()
        targetElement.setSelectionRange(length, length)
      } else {
        targetElement.focus()
      }
    }
    FastClick.attach(document.body)
  }
})



// WEBPACK FOOTER //
// ./src/main.js